import { GET_STUDENT_EIS_DOP_RECOMMENDATIONS } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponse, IEisDopRecommendation } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentEisDopRecommendationsState = ICommonResponse<IEisDopRecommendation>;

const initialState: StudentEisDopRecommendationsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<StudentEisDopRecommendationsState>();
const studentEisDopRecommendations: IReducers<StudentEisDopRecommendationsState> = {
  [GET_STUDENT_EIS_DOP_RECOMMENDATIONS[REQUEST]]: generic.get.request,
  [GET_STUDENT_EIS_DOP_RECOMMENDATIONS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_EIS_DOP_RECOMMENDATIONS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_EIS_DOP_RECOMMENDATIONS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentEisDopRecommendations);
